var map = {
	"./icon_coordinates1.png": "b12d",
	"./icon_coordinates10.png": "1a58",
	"./icon_coordinates2.png": "80a7",
	"./icon_coordinates3.png": "69d0",
	"./icon_coordinates4.png": "e33f",
	"./icon_coordinates5.png": "2d2f",
	"./icon_coordinates6.png": "9366",
	"./icon_coordinates7.png": "1806",
	"./icon_coordinates8.png": "2482",
	"./icon_coordinates9.png": "ad2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cdb";